"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ol = require("ol");

var _Control = _interopRequireDefault(require("ol/control/Control"));

require("ol/ol.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * <p>
 *  A control is a visible widget with a DOM element in a fixed 
 *  position on the screen. They can involve user input (buttons), 
 *  or be informational only; the position is determined using CSS. 
 *  By default these are placed in the container with CSS class name
 *  ol-overlaycontainer-stopevent, but can use any outside DOM element.
 * </p>
 * 
 * @visibleName Custom Control
 */
var CustomControl = function CustomControl(_ref) {
  var map = _ref.map,
      options = _ref.options,
      children = _ref.children;
  var elementRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var opts = _objectSpread(_objectSpread({}, options), {}, {
      element: elementRef.current
    });

    delete opts.className;
    var control = new _Control.default(opts);
    map.addControl(control);
    return function () {
      map.removeControl(control);
    };
  }, [map, options]);
  var StyledChildren = (0, _react.useCallback)(function () {
    return _react.default.Children.map(children, function (child) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        //className: `${child.props.className} ${options.className}`
        className: options.className
      });
    });
  }, [children, options.className]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: elementRef,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledChildren, {})
  });
};

CustomControl.propTypes = {
  /**
   * The OpenLayers ol/Map container for the component.
   */
  map: _propTypes.default.instanceOf(_ol.Map),

  /**
   * The options for the component. 
   */
  options: _propTypes.default.object
};
var _default = CustomControl;
exports.default = _default;